export default __webpack_public_path__ + "static/media/add-icon-new-v2.e1e83c42.svg";